<style>
  .navbar-right .dropdown-menu li:last-child {
  border-bottom: 0;
}
.dropdown-submenu > a:after {
content: "\25BA" !important;
}
.dropdown-submenu > a:before {
content: none !important;
}
</style>
<div class="top">
  <div class="{{(popupMode$ | async) ? 'container-fluid' : 'container'}}">
    <div id="global-buttons" class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
      <div class="btn-group navbar-right" role="group" aria-label="...">
        @if (!(popupMode$ | async)) {
          <div class="btn global-btn phone-btn hide">
            <a href="">
              <em class="icon-help">
              </em>
              <span class="hidden-xs hidden-sm">{{ 'HELP' | translate }}</span>
            </a>
          </div>
          <div class="btn global-btn phone-btn">
            <a routerLink="/resource/iac/Training_Modules.html" target="_blank" rel="noopener noreferrer">
              <em class="icon-training"></em>
              <span class="hidden-xs hidden-sm"> {{ 'Training' | translate }}</span>
            </a>
          </div>
          <div class="btn global-btn phone-btn">
            <a routerLink="/resource/iac/contact-us.html">
              <em class="icon-phone">
              </em>
              <span class="hidden-xs hidden-sm"> {{ 'Contact Us' | translate }}</span>
            </a>
          </div>
          <div class="btn-group" role="group">
            <div class="btn global-btn globe-btn dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
              <a href="#" (mouseenter)="mouseEnter() " (mouseleave)="mouseLeave()">
                <img src={{lang_img}} class="  " [alt]="lang_img">
                <span class="hidden-xs hidden-sm">{{ 'Languages' | translate }}</span>
              </a>
            </div>
            <ul class="dropdown-menu" role="menu">
              <li>
                <a (click)="switchLanguage('zh')">{{ 'Chinese' | translate }}</a>
              </li>
              <li>
                <a (click)="switchLanguage('en')">{{ 'English' | translate }}</a>
              </li>
              <li>
                <a (click)="switchLanguage('fr')">{{ 'French' | translate }}</a>
              </li>
              <li>
                <a (click)="switchLanguage('pt-BR')">{{ 'Portuguese (Brazilian)' | translate }}</a>
              </li>
              <li>
                <a (click)="switchLanguage('pt')">{{ 'Portuguese (European)' | translate }}</a>
              </li>
              <li>
                <a (click)="switchLanguage('ru')">{{ 'Russian' | translate }}</a>
              </li>
              <li>
                <a (click)="switchLanguage('es')">{{ 'Spanish' | translate }}</a>
              </li>
            </ul>
          </div>
          <div class="btn global-btn phone-btn">
            <a href="https://www.cummins.com/locations/" target="_blank" rel="noopener noreferrer">
              <em class="icon-locator">
              </em>
              <span class="hidden-xs hidden-sm">{{ 'Service Locator' | translate }}</span>
            </a>
          </div>
          @if (accessFlags.isCMSAdmin) {
            <div id="cms-div" class="btn global-btn phone-btn">
              <a (click)="gotoEditor()">
                <em id="cms-icon" class="app-icon pi pi-pencil"></em>
                <span class="hidden-xs hidden-sm">{{ 'CMS Editor' | translate }}</span>
              </a>
            </div>
          }
          <div class="btn-group" role="group">
            @if (userId != 'Login') {
              <div class="btn global-btn globe-btn dropdown-toggle"
                data-toggle="dropdown" aria-expanded="false">
                <a href="#">
                  {{ 'QuickServe' | translate }}<span class="hidden-xs hidden-sm"> {{ 'Online' | translate }}</span>
                </a>
              </div>
            } @else {
              <div class="btn global-btn phone-btn">
                <a [href]="'/info/index.html' | resource: 'QSOL_HOST'" target="_blank">
                  {{ 'QuickServe' | translate }}<span class="hidden-xs hidden-sm"> {{ 'Online' | translate }}</span>
                </a>
              </div>
            }
            @if (userId != 'Login') {
              <ul class="dropdown-menu" role="menu" style="min-width: 140px;">
                <li>
                  <a (click)="redirectToQsol()">{{ 'Home' | translate }}</a>
                </li>
                <li>
                  <a [href]="'/index.html' | resource: 'RESTART_HOST'" target="_blank">{{ 'ReCon Tools' | translate }}</a>
                </li>
              </ul>
            }
          </div>
        } @else {
          <div class="btn global-btn phone-btn">
            <a (click)="openHelpDeskPage()">
              <span>{{ 'Contact Us - Help Ticket' | translate }}</span>
            </a>
          </div>
        }
      </div>
    </div>
  </div>
</div>
<div class="header">
  <div class=" navbar" role="navigation">
    <div class="container-fluid">
      <div class="navbar-header">
        <div class="logo col-xs-2 col-sm-2 col-md-3 col-lg-3">
          @if (!(popupMode$ | async)) {
            <a routerLink="/">
              <ng-container *ngTemplateOutlet="logo"></ng-container>
            </a>
          } @else {
            <div class="logo_img" title="Cummins">
              <img-xhr [src]="getAssetsLink('/navigation/cummins_logo.png')" alt="logo"></img-xhr>
            </div>
            <div class="hidden-sm hidden-xs sub-brand">
              <h2>{{'Genuine Parts' | translate }}</h2>
            </div>
          }
          <ng-template #logo>
            <div class="logo_img" title="Cummins">
              <img-xhr [src]="getAssetsLink('/navigation/cummins_logo.png')" alt="logo"></img-xhr>
            </div>
            <div class="hidden-sm hidden-xs sub-brand">
              <h2>{{'Genuine Parts' | translate }}</h2>
            </div>
          </ng-template>
        </div>
        @if (!(popupMode$ | async)) {
          <div class="col-lg-4 col-md-4 col-xs-8" style="margin-top: 15px;">
            <form class="form-search" id="searchForm" (ngSubmit)="goToSearch()" [formGroup]="searchForm">
              <div class="input-group">
                <span class="input-group-btn">
                  <button (click)="goToSearchHelp()" title="{{ 'How to Find What You Want' | translate }}?" class="btn btn-default" type="button">
                    <em class="app-icon pi pi-question-circle" aria-hidden="true"></em>
                  </button>
                </span>
                <input name="criteria" [(ngModel)]="srchCriteria" id="criteria" class="form-control" placeholder="{{placeholder.title | translate}}" required autocomplete="off" formControlName="searchValue">
                <div class="input-group-btn">
                  <span class="input-group-btn">
                    <button type="submit" name="search" class="btn btn-default" [disabled]="searchForm?.invalid">
                      @if (showSearch) {
                        <em class="app-icon pi pi-search"></em>
                      }
                    </button>
                  </span>
                </div>
              </div>
            </form>
            @if (searchForm.invalid && (searchForm.dirty || searchForm.touched)) {
              <div class="error-msg">
                @if (searchForm.controls['searchValue'].errors.needsAplhaNumeric) {
                  <div>
                    {{ 'Input should be 3 characters long.' | translate }}
                  </div>
                }
                @if (searchForm.controls['searchValue'].errors.needsDigit) {
                  <div>
                    <span>{{ 'Too few numbers were entered into the search.' | translate }}</span>
                    <span class="clearfix"></span>
                    <span>{{ 'Please enter a minimum of 4 and try again.' | translate }}</span>
                  </div>
                }
              </div>
            }
          </div>
        }
        @if (accessFlags.showSurveyLink) {
          <div class="col-sm-4 col-md-4 col-lg-4 d-flex justify-content-between">
            <span class="text-right" id="surveylink"
            [innerHTML]="'survey_link.html' | cmsResource | async | sanitizeHtml"></span>
          </div>
        }
        <div class="hidden-md hidden-sm" style="display: inline-block;">
          @if (!(popupMode$ | async)) {
            <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse"
              >
              <span class="sr-only">{{ 'Toggle navigation' | translate }}</span>
              <span class="app-icon pi pi-bars" style="font-size: 3rem !important;"></span>
            </button>
          } @else {
            @if (isLoggedIn) {
              <span class="navbar-toggle"
                style="position: absolute; bottom: 0; right: 0; vertical-align: bottom;">
              {{ userId }}</span>
            }
          }
        </div>


      </div>
      <nav class="collapse navbar-collapse hidden-xs hidden-sm">
        <ul class="nav navbar-nav">
          @if (!(popupMode$ | async)) {
            <li>
              <a routerLink="/">
                <span class=""></span>{{ 'Home' | translate }}</a>
              </li>
              <li class="divider"></li>
              <li class="banner-dropdown">
                <a href="#" class="dropdown-toggle" data-toggle="dropdown">{{ 'Products' | translate }}
                  <strong class="caret"></strong>
                </a>
                <ul class="dropdown-menu multi-level">
                  <li>
                    <a routerLink="/esn-entry">{{ 'Engine Parts' | translate }}</a>
                  </li>
                  <li>
                    <a routerLink="/gsn-entry">{{ 'Power Generation' | translate }}</a>
                  </li>
                  <li>
                    <a routerLink="/ctt-entry">{{ 'Turbochargers' | translate }}</a>
                  </li>
                  <li>
                    <a routerLink="/esn-entry/npbu">{{ 'Electrified Power Products' | translate }}</a>
                  </li>
                  <li>
                    <a routerLink="/atsn-entry">{{ 'Aftertreatment' | translate }}</a>
                  </li>
                  <li>
                    <a href="{{storeUrl}}" target="_blank" rel="noopener noreferrer">{{ 'Publications' | translate }}</a>                               </li>
                    <li>
                      <a routerLink="/mst-entry/main/home-page">{{ 'Service Tools and Consumables' | translate }}</a>
                    </li>
                  </ul>
                </li>
                <li class="divider"></li>
                <li class="banner-dropdown">
                  <a href="#" class="dropdown-toggle" data-toggle="dropdown">{{ 'Resources' | translate }}
                    <strong class="caret"></strong>
                  </a>
                  <ul class="dropdown-menu">
                    <li>
                      <a routerLink="/mst-entry/main/home-page">{{ 'Electrical Connectors' | translate }}</a>
                    </li>
                    @if (showSbomMenu$ | async) {
                      <li>
                        @switch ((sbomLoaderEvents$ | async)?.type) {
                          @case ('pending') {
                            <a class="disabled-link" type="menu" role="link">
                              <strong><em class="app-icon pi pi-spin pi-spinner"></em> {{ 'Downloading..!' | translate }}</strong>
                            </a>
                          }
                          @default {
                            <a type="menu" role="link" (click)="downloadSbom($event);">{{ 'Service BOM' |
                              translate }} (<strong>{{esn$ | async}}</strong>)</a>
                            }
                          }
                        </li>
                      }
                      @if (userId != 'Login') {
                        <li>
                          <a [href]="'CUMPASS_HOST' | env" target="_blank" rel="noopener noreferrer">{{ 'Cumpas 2.0' | translate }}</a>
                        </li>
                      }
                      @if (accessFlags.isUploadUpfitAllowed) {
                        <li>
                          <a routerLink="/upfits/add-upfits">{{ 'Add Upfit' | translate }}</a>
                        </li>
                      }
                      @if (accessFlags.isAdmin || accessFlags.isSuperAdmin) {
                        <li>
                          <a [href]="adminView" target="_blank">{{ 'User Management' | translate }}</a>
                        </li>
                      }
                      <!--Added for CMS testing starts-->
                      @for (items of menu; track items.name) {
                        <li [ngClass]="{'dropdown-submenu' : items.type == 'D'}">
                          @if (items.title !== 'About Us' && items.title !=='Contact Us') {
                            @if (items.type !='D') {
                              <a routerLink="/resource/{{application}}/{{items.name}}"
                                [title]="items.title | translate | titlecase">
                              {{items.title | translate | titlecase}}</a>
                            }
                            @if (items.type == 'D') {
                              <a [title]="items.title | translate | titlecase"
                                [ngClass]="{'after' : items.type == 'D'}">
                              {{items.title || items.name | translate | titlecase }}{{' '}}</a>
                            }
                            @if (items.type == 'D') {
                              <ul  class="dropdown-menu level-two">
                                @for (item of items.children; track item.name) {
                                  <li>
                                    @if (item.type !='D') {
                                      <a routerLink="/resource/{{application}}/{{items.name}}/{{item.name}}"
                                        [title]="item.title | translate | titlecase">
                                      {{item.title | translate | titlecase}}</a>
                                    }
                                  </li>
                                }
                                @if (items.name == 'media-center') {
                                  <li>
                                    <a href="https://www.cummins.com/news" target="_blank" rel="noopener noreferrer">{{ 'News and Press Releases' | translate }}</a>
                                  </li>
                                }
                                @if (items.name == 'media-center') {
                                  <li>
                                    <a href="https://www.youtube.com/@cummins" target="_blank" rel="noopener noreferrer">{{ 'Videos' | translate }}</a>
                                  </li>
                                }
                              </ul>
                            }
                          }
                        </li>
                      }
                      <li>
                        <a href="https://www.cummins.com/company/global-websites" target="_blank" rel="noopener noreferrer">{{ 'Other Cummins Websites' | translate }}</a>
                      </li>
                      <li>
                        <a href="https://www.cummins.com/support/product-registration" target="_blank" rel="noopener noreferrer">{{ 'Product Registration' | translate }}</a>
                      </li>
                      @if (userId != 'Login') {
                        <li>
                          <a [href]="'/index.html' | resource: 'RESTART_HOST'" target="_blank">{{ 'ReCon Tools' | translate }}</a>
                        </li>
                      }
                    </ul>
                  </li>
                  <li class="divider"></li>
                  @if (checkLogout()) {
                    <li class="banner-dropdown">
                      <a href="#" class="dropdown-toggle" data-toggle="dropdown">{{userId}}
                        <strong class="caret"></strong>
                      </a>
                      <ul class="dropdown-menu multi-level">
                        @if (!isIntegrationFlow) {
                          <li>
                            <a class="" [href]="'/qs3/portal/settings/index.html' | resource: 'QSOL_HOST'" target="_blank">{{'My Profile' |  translate}}</a>
                          </li>
                          <li>
                            <a (click)="gotoSavedEsn()">{{ 'My Saved ESNs' | translate }}</a>
                          </li>
                          @if (isServiceToolsAdmin) {
                            <li>
                              <a routerLink="/mst-admin">{{ 'Service Tools Admin' | translate }}</a>
                            </li>
                          }
                        }
                        <li>
                          <a (click)="logout()">{{ 'Not' | translate }} {{userId}}? {{ 'Sign Out' | translate }}</a>
                        </li>
                      </ul>
                    </li>
                  }
                  <li>
                    @if (!checkLogout()) {
                      <a routerLink="/login">{{userId | translate}} </a>
                    }
                  </li>
                  <li class="divider"></li>
                  <li>
                    <a routerLink="/wish-list" [title]="cartLoading ? ('Loading User Pick List..!' | translate) : ('Pick List' | translate)">
                      <em class=""></em> {{ 'Pick List' | translate }}
                      <span class="badge picklist-icon">
                        @if (cartLoading && initLoading) {
                          <em class="app-icon pi pi-spin pi-spinner"></em>
                        }
                        @if (cartLoading && !initLoading) {
                          -
                        }
                        @if (!cartLoading && initLoading) {
                          {{cnt}}
                        }
                      </span>
                    </a>
                  </li>
                } @else {
                  @if (isLoggedIn) {
                    <li>
                      <a [class.passive]="popupMode$ | async">{{ userId }}</a>
                    </li>
                  }
                }
              </ul>
            </nav>
          </div>
          @if (!(popupMode$ | async)) {
            <div class="mobile-menu hidden-md hidden-sm">
              <div id="navbar" class="navbar-collapse collapse">
                <ul class="nav navbar-nav">
                  @if (checkLogout()) {
                    <li class="banner-dropdown">
                      <a href="#" class="dropdown-toggle" data-toggle="dropdown">{{userId | translate }}
                        <strong class="caret"></strong>
                      </a>
                      <ul class="dropdown-menu multi-level">
                        @if (!isIntegrationFlow) {
                          <li>
                            <a class="" [href]="'/qs3/portal/settings/index.html' | resource: 'QSOL_HOST'" target="_blank">{{'My Profile' |  translate}}</a>
                          </li>
                          <li>
                            <a (click)="gotoSavedEsn()">{{ 'My Saved ESNs' | translate }}</a>
                          </li>
                          @if (isServiceToolsAdmin) {
                            <li>
                              <a routerLink="/mst-admin">{{ 'Service Tools Admin' | translate }}</a>
                            </li>
                          }
                        }
                        <li>
                          <a (click)="logout()">{{ 'Not' | translate }} {{userId}}? {{ 'Sign Out' | translate }}</a>
                        </li>
                      </ul>
                    </li>
                  }
                  <li>
                    @if (!checkLogout()) {
                      <a routerLink="/login">{{userId | translate}} </a>
                    }
                  </li>
                  <li class="active">
                    <a routerLink="/">
                      <em class="app-icon pi pi-home"></em> {{ 'Home' | translate }}</a>
                    </li>
                    <li class="dropdown">
                      <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">{{ 'Products' | translate }}
                        <span class="caret"></span>
                      </a>
                      <ul class="dropdown-menu">
                        <li>
                          <a routerLink="/esn-entry">{{ 'Engine Parts' | translate }}</a>
                        </li>
                        <li>
                          <a routerLink="/gsn-entry">{{ 'Power Generation' | translate }}</a>
                        </li>
                        <li>
                          <a routerLink="/ctt-entry">{{ 'Turbochargers' | translate }} </a>
                        </li>
                        <li>
                          <a routerLink="/atsn-entry">{{ 'Aftertreatment' | translate }}</a>
                        </li>
                        <li>
                          <a href="{{storeUrl}}" target="_blank" rel="noopener noreferrer">{{ 'Publications'| translate }}</a> </li>          <li>
                          <a routerLink="/mst-entry/main/home-page">{{ 'Service Tools and Consumables' | translate }}</a>
                        </li>
                      </ul>
                    </li>
                    <li class="nav-item dropdown" dropdown [autoClose]="false">
                      <a dropdownToggle class="dropdown-toggle" (click)="$event.preventDefault()" style="cursor: pointer;">
                        {{ 'Resources' | translate }}
                        <strong class="caret"></strong>
                      </a>
                      <ul class="dropdown-menu" role="menu">
                        <li>
                          <a routerLink="/mst-entry/main/home-page">{{ 'Electrical Connectors' | translate }}</a>
                        </li>
                        @if (showSbomMenu$ | async) {
                          <li>
                            @switch ((sbomLoaderEvents$ | async)?.type) {
                              @case ('pending') {
                                <a class="disabled-link" type="menu" role="link">
                                  <strong><em class="app-icon pi pi-spin pi-spinner"></em> {{ 'Downloading..!' | translate }}</strong>
                                </a>
                              }
                              @default {
                                <a type="menu" role="link" (click)="downloadSbom($event);">{{ 'Service BOM' |
                                  translate }} (<strong>{{esn$ | async}}</strong>)</a>
                                }
                              }
                            </li>
                          }
                          @if (userId != 'Login') {
                            <li>
                              <a [href]="'CUMPASS_HOST' | env" target="_blank" rel="noopener noreferrer">{{ 'Cumpas 2.0' | translate }}</a>
                            </li>
                          }
                          @if (accessFlags.isUploadUpfitAllowed) {
                            <li>
                              <a routerLink="/upfits/add-upfits">{{ 'Add Upfit' | translate }}</a>
                            </li>
                          }
                          @if (accessFlags.isAdmin || accessFlags.isSuperAdmin) {
                            <li>
                              <a [href]="adminView" target="_blank">{{ 'User Management' | translate }}</a>
                            </li>
                          }
                          <li>
                          </li>
                          <!--Added for CMS testing starts-->
                          @for (items of menu; track items.name) {
                            <li class="dropdown-submenu"
                              placement="right"
                              container="body"
                              [triggers]="'click'">
                              @if (items.title !== 'About Us' && items.title !=='Contact Us') {
                                @if (items.type !='D') {
                                  <a
                                  routerLink="/resource/{{application}}/{{items.name}}"> {{items.title | translate | titlecase}}</a>
                                }
                                @if (items.type == 'D') {
                                  <a dropdownToggle
                                    class="dropdown-item dropdown-toggle"
                                    (click)="$event.stopPropagation(); $event.preventDefault()">
                                    {{items.title || items.name | translate | titlecase }}
                                  </a>
                                }
                                @if (items.type == 'D') {
                                  <ul class="dropdown-menu">
                                    @for (item of items.children; track item.name) {
                                      <li>
                                        @if (item.type !='D') {
                                          <a class="dropdown-item"
                                            routerLink="/resource/{{application}}/{{items.name}}/{{item.name}}">
                                          {{item.title | translate | titlecase}}</a>
                                        }
                                      </li>
                                    }
                                    @if (items.name == 'media-center') {
                                      <li>
                                        <a href="https://www.cummins.com/news" target="_blank" rel="noopener noreferrer">{{ 'News and Press Releases' | translate }}</a>
                                      </li>
                                    }
                                    @if (items.name == 'media-center') {
                                      <li>
                                        <a href="https://www.youtube.com/@cummins" target="_blank" rel="noopener noreferrer">{{ 'Videos' | translate }}</a>
                                      </li>
                                    }
                                  </ul>
                                }
                              }
                            </li>
                          }
                          <li>
                            <a href="https://www.cummins.com/company/global-websites" target="_blank" rel="noopener noreferrer">{{ 'Other Cummins Websites'| translate }}</a>
                          </li>
                          <li>
                            <a href="https://www.cummins.com/support/product-registration" target="_blank" rel="noopener noreferrer">{{ 'Product Registration'| translate }}</a>
                          </li>
                          @if (userId != 'Login') {
                            <li>
                              <a [href]="'/index.html' | resource: 'RESTART_HOST'" target="_blank">{{ 'ReCon Tools' | translate }}</a>
                            </li>
                          }
                        </ul>
                      </li>
                      <li>
                        <a routerLink="/wish-list">
                          <em class=""></em> {{ 'Pick List' | translate }}
                          <span class="badge picklist-icon"> {{cnt}}</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              }
            </div>
          </div>
          <div id="popover-content" class="hide">
            @if (!checkLogout()) {
              <div class="">
                <div class="">
                  <a class="col-md-12  primary-cta btn  btn-lg " routerLink="/login">{{ 'Sign In'| translate }}</a>
                </div>
                <div class="col-md-12 text-center">
                  <label>
                    <span>{{ 'New Customer - ' | translate }}</span>
                  </label>&nbsp;&nbsp;&nbsp;
                  <a class="" routerLink="/signUp">{{ 'Register Now?' | translate }}</a>
                </div>
              </div>
            }
            @if (checkLogout()) {
              <div class="">
                @if (!isIntegrationFlow) {
                  <div class="col-md-12">
                    <a class="col-md-12  primary-cta btn  btn-lg " [href]="'/qs3/portal/settings/index.html' | resource: 'QSOL_HOST'" target="_blank">{{'My Profile' |  translate}}</a>
                  </div>
                }
                <div class="col-md-12">
                  <a class="col-md-12  primary-cta btn  btn-lg " #signout (click)="onChange($event)">{{ 'Not' | translate }} {{userId | translate }}? {{ 'Sign Out' | translate }}</a>
                </div>
                <div class="col-md-12 text-center">
                </div>
              </div>
            }
          </div>
          <!-- Login Popover Section-->
          <div class="">
            <toaster-container></toaster-container>
          </div>
